import React, { useEffect, useRef, useState } from 'react'

import { ModalBox, useMediaQueryContext } from '@fourthwall/components'

import * as S from './styled'

type Props = {
  images: { id: string; url: string }[]
  selectedImageId: string
  close: () => void
}

export const GalleryModal = ({ images, selectedImageId, close }: Props) => {
  const [selectedImage, setSelectedImage] = useState(selectedImageId)
  const media = useMediaQueryContext()
  const initialSelectedImageIndex = images.findIndex(({ id }) => id === selectedImageId)
  const showSlider = !media.tablet
  const sliderRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (showSlider && sliderRef.current) {
      const selectedSlide = sliderRef.current.children[initialSelectedImageIndex] as HTMLElement
      if (selectedSlide) {
        setTimeout(() => {
          selectedSlide.scrollIntoView({
            behavior: 'instant',
            block: 'nearest',
            inline: 'center',
          })
        }, 0)
      }
    }
  }, [initialSelectedImageIndex, showSlider])

  if (showSlider) {
    return (
      <ModalBox size="fullScreen" withoutPadding onClose={close} disableScrolling>
        <S.SliderContainer>
          <S.Slider ref={sliderRef}>
            {images.map((image) => (
              <S.Slide key={image.id}>
                <S.ImagesListItemImage src={image.url} data-testid="GalleryModal.ImagesListItem" />
              </S.Slide>
            ))}
          </S.Slider>
        </S.SliderContainer>
      </ModalBox>
    )
  }

  return (
    <ModalBox size="fullScreen" disableScrolling onClose={close}>
      <S.Container>
        <S.SelectedImageContainer>
          <S.SelectedImage
            src={images.find(({ id }) => id === selectedImage)?.url}
            data-testid="GalleryModal.SelectedImage"
          />
        </S.SelectedImageContainer>
        <S.ImagesList>
          {images.map((image) => (
            <S.ImagesListItem
              key={image.id}
              $active={image.id === selectedImage}
              onClick={() => setSelectedImage(image.id)}
              data-testid="GalleryModal.ImagesListItem"
            >
              <S.ImagesListItemImage src={image.url} />
            </S.ImagesListItem>
          ))}
        </S.ImagesList>
      </S.Container>
    </ModalBox>
  )
}
